import React from 'react';
import { useNavigate } from 'react-router-dom';
import { markNotificationAsRead } from '../../services/notificationService';
import Button from '../common/Button';
import { Caption } from '../common/Typography';
import CollapsibleNotificationItem from '../notifications/CollapsibleNotificationItem';

/**
 * ClubJoinRequestApprovedNotificationItem Component
 * Notification item for approved join requests
 */
const ClubJoinRequestApprovedNotificationItem = ({ 
  notification, 
  currentUser,
  onUpdate,
  onClose 
}) => {
  const navigate = useNavigate();
  const notificationData = notification.data || {};
  const clubId = notificationData.club_id;
  const clubName = notificationData.club_name || 'the club';

  const handleGoToClub = async () => {
    // Mark notification as read
    if (notification.id && !notification.is_read) {
      try {
        await markNotificationAsRead(notification.id);
      } catch (err) {
        console.error('Error marking notification as read:', err);
      }
    }

    // Close notifications modal
    if (onClose) {
      onClose();
    }

    // Navigate to the club page
    if (clubId) {
      navigate(`/club/${clubId}`);
    }

    // Update notifications list
    if (onUpdate) {
      onUpdate();
    }
  };

  const metadata = clubName && (
    <Caption>Club: {clubName}</Caption>
  );

  return (
    <CollapsibleNotificationItem
      notification={notification}
      borderColor="green"
      badgeVariant="success"
      metadata={metadata}
    >
      <Button
        variant="primary"
        size="small"
        onClick={handleGoToClub}
      >
        View Club
      </Button>
    </CollapsibleNotificationItem>
  );
};

export default ClubJoinRequestApprovedNotificationItem;

